import { CurrencyPipe } from '@angular/common';
import { ChangeCharacterFromIssue } from 'src/shared';
import { BlotterOrderItem } from './blotterCapitals.component';

const sortable = true;
const sensitive = true;
const canBeSkeleton = true;

const numberFormats = {
  integers: '0,0',
  moneyTwoDecimals: '$0,0[.]00',
  moneyThreeDecimals: '$,0[.]00[0]',
  eightDecimals: '0,0.00000000',
};

export const TRADING_MX_COLUMNS: DisplayedCapitalBlotterColumn[] = [
  { key: 'hour', title: 'Hora', sortable },
  {
    key: 'sobId',
    title: 'Folio',
  },
  {
    key: 'issueId',
    title: 'Emisora',
    sortable,
    csvFormatter: (value) =>
      new ChangeCharacterFromIssue().ChangeAmpersand(value),
  },
  { key: 'capitalOrderType', title: 'Tipo de Orden', sortable },
  { key: 'way', title: 'Sentido', sortable },
  {
    key: 'originalQuantity',
    title: 'Títulos',
    sensitive,
    customFormat: numberFormats.integers,
  },
  {
    key: 'assignedQuantity',
    title: 'Asignados',
    sensitive,
    customFormat: numberFormats.integers,
  },
  {
    key: 'price',
    title: 'Precio',
    customFormat: numberFormats.moneyTwoDecimals,
    customFormatLessThanOne: numberFormats.moneyThreeDecimals,
    csvFormatter: (value) =>
      new CurrencyPipe('es-MX').transform(
        value,
        'MXN',
        'symbol-narrow',
        '1.2-2',
      ),
  },
  {
    key: 'averagePrice',
    title: 'Precio Promedio',
    customFormat: numberFormats.moneyTwoDecimals,
    customFormatLessThanOne: numberFormats.moneyThreeDecimals,
    csvFormatter: (value) =>
      new CurrencyPipe('es-MX').transform(
        value,
        'MXN',
        'symbol-narrow',
        '1.2-2',
      ),
  },
  { key: 'durationText', title: 'Vigencia' },
  { key: 'esStatus', title: 'Estado' },
];

export const TRADING_USA_COLUMNS: DisplayedCapitalBlotterColumn[] = [
  { key: 'hour', title: 'Hora', sortable },
  {
    key: 'issueId',
    title: 'Emisora',
    sortable,
    canBeSkeleton,
    csvFormatter: (value) =>
      new ChangeCharacterFromIssue().ChangeAmpersand(value),
  },
  { key: 'capitalOrderType', title: 'Tipo de Orden', sortable },
  { key: 'way', title: 'Sentido', sortable },
  {
    key: 'approximatedTitles',
    title: 'Títulos aproximados',
    customFormat: numberFormats.eightDecimals,
    sensitive,
    canBeSkeleton,
  },
  {
    key: 'amount',
    title: 'Monto',
    sensitive,
    canBeSkeleton,
    customFormat: numberFormats.moneyTwoDecimals,
    customFormatLessThanOne: numberFormats.moneyThreeDecimals,
    csvFormatter: (value) =>
      new CurrencyPipe('es-MX').transform(
        value,
        'MXN',
        'symbol-narrow',
        '1.2-2',
      ),
  },
  { key: 'esStatus', title: 'Estado' },
];

export interface DisplayedCapitalBlotterColumn {
  key: keyof BlotterOrderItem;
  title: string;
  sortable?: boolean;
  sensitive?: boolean;
  customFormat?: string;
  customFormatLessThanOne?: string;
  canBeSkeleton?: boolean;
  csvFormatter?: (value: any) => string;
}
